import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";

//Components
import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Actions
import { openModalConfirmResolveMaintenanceWarningEvent } from 'Redux/actions';
import { reset } from './redux/slice';

//Styles
import './index.scss';

const ResolveMaintenanceWarningsEvent = (props) => {
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(reset())
    }

    //Redux States
    const { loading, data, openModal } = useSelector(state => state.maintenanceWarningsConfirmResolveRedux);
    const { loadingLabels } = useSelector(state => state.maintenanceWarningsRedux);

    const timeFromDate = (date, language = 'en') => {
        const dateMoment = moment(date).locale(language);
        const timeElapsed = dateMoment.fromNow();
        return timeElapsed;
    }

    const generateSummary = (lang) => {
        let description = null
        try {
            let labels = localStorage.getItem("langByS3")
            labels = labels.replace('export default ', '');
            labels = JSON.parse(JSON.parse(labels));
            for (const key in labels) {
                /* if (key.includes("DrivingOver18Hours_CheckWiring")) {
                    description = labels[key]
                } */
                if (key.includes(data?.warning)) {
                    description = labels[key]
                }
            }
        } catch (exc) {

        }
        if (description) {
            return (
                <div className="container-warning-summary">
                    <span style={{ opacity: 0.5 }}>{getDateFormatted(data?.lastEventDate, "date", "datetime", null, data?.timezone)} {` (${timeFromDate(data?.lastEventDate, lang)})`}</span>
                    <h2 style={{ marginTop: 10 }}>{messages[`maintenance_warnings_tab_${data?.warning}`] || data?.warning}</h2>
                    <div
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </div>
            )
        } else {
            return (
                <div className="container-warning-summary">
                    <span style={{ opacity: 0.5 }}>{getDateFormatted(data?.lastEventDate, "date", "datetime", null, data?.timezone)} {` (${timeFromDate(data?.lastEventDate, lang)})`}</span>
                    <h2 style={{ marginTop: 10 }}>{messages[`maintenance_warnings_tab_${data?.warning}`] || data?.warning}</h2>
                    <div>
                        <p>{messages['maintenance_warnings_tab_default_message']}</p>
                    </div>
                </div>
            )
        }

    }

    const applyChanges = () => {
        dispatch(openModalConfirmResolveMaintenanceWarningEvent(data))
    }

    const summary = generateSummary(locale);

    return (
        <Modal
            open={openModal}
            title={`${data?.unitLabel || messages[`maintenance_warnings_tab_${data?.warning}`] || data?.warning || ''}`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading || loadingLabels}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <a onClick={() => closeModal()} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{messages['maintenance_warnings_tab_back_to_issues']}</a>
                    {
                        !loading && (
                            <>
                                {summary}
                            </>
                        )
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_close']}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['maintenance_warnings_tab_resolve']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ResolveMaintenanceWarningsEvent;